import React from 'react';
import type { FieldValues } from 'react-hook-form';
import { Controller } from 'react-hook-form';

import type { InputRadioGroupProps } from '../types';

import InputRadioGroupControl from './InputRadioGroupControl';

export default function InputRadioGroup<T extends FieldValues>({
  control,
  ...props
}: InputRadioGroupProps<T>) {
  return (
    <Controller
      control={control}
      name={props.name}
      render={({ field: { onChange } }) => (
        <InputRadioGroupControl {...props} onChange={onChange} />
      )}
    />
  );
}
